import React, { useEffect, useState } from 'react';

const CircularProgress = ({ score, size = 116, strokeWidth = 9, className = '' }) => {
  const [offset, setOffset] = useState(283);
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;

  useEffect(() => {
    if (score == null) {
      setOffset(circumference);
      return;
    }
    const timer = setTimeout(() => {
      setOffset(circumference - (score / 100) * circumference);
    }, 100);
    return () => clearTimeout(timer);
  }, [score, circumference]);

  return (
    <div className={`relative inline-flex items-center justify-center ${className}`}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          className="text-gray-200 dark:text-gray-700"
        />
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="text-primary-500 dark:text-primary-400 solar-glow transition-[stroke-dashoffset] duration-1000 ease-out"
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-4xl font-bold text-solar tabular-nums leading-none">
          {score != null ? Math.round(score) : '—'}
        </span>
        {score != null && (
          <span className="mt-0.5 text-sm font-medium text-gray-500 dark:text-gray-400">/ 100</span>
        )}
      </div>
    </div>
  );
};

export default CircularProgress;
